// 販売
// タイプ
const STATUS_HISTORY_TYPE_ID = {
  CONFIRM: 4,
  PAYMENT: 1,
  SHIP: 2,
  COMPLETE: 3,
  STATUS_NOTIFICATION: 5
}
// タイプ名
const STATUS_HISTORY_TYPE_LABEL = {
  CONFIRM: '注文確定',
  PAYMENT: '入金',
  SHIP: '出庫',
  COMPLETE: '完成',
  STATUS_NOTIFICATION: ''
}

// 入金状態
const CONFIRM_STATUS = {
  ALL: 0,
  BEFORE_PAYMENT: 1,
  AFTER_PAYMENT: 4
}
// 入金状態
const PAYMENT_STATUS = {
  ALL: 0,
  BEFORE_PAYMENT: 1,
  AFTER_PAYMENT: 4
}
// 出庫状態
const SHIP_STATUS = {
  ALL: 0,
  BEFORE_SHIP: 2,
  AFTER_SHIP: 5
}
// 注文状態
const COMPLETE_STATUS = {
  ALL: 0,
  BEFORE_COMPLETE: 3,
  AFTER_COMPLETE: 6,
  CANCEL: 99
}

const STATUS_HISTORY_LABEL = {
  ALL: 'common.common_overall',
  BEFORE_PAYMENT: 'payment.payment_not-sale-payment',
  BEFORE_SHIP: 'ship.ship_not-ship',
  BEFORE_COMPLETE: 'order.order_unfinished',
  AFTER_PAYMENT: 'payment.payment_already-sale-payment',
  AFTER_SHIP: 'ship.ship_already-ship',
  AFTER_COMPLETE: 'sale.sale_completion',
  CANCEL: 'order.order_canceled-label',
  CONFIRMING: 'order.order_order-not-confirmed',
  REGISTER_SHIPPING: 'sale.sale_confirmed',
  SHIPPED: 'sale.sale_shipped'
}

const CUSTOMER_ORDER_STATUS_HISTORY = {
  CONFIRMING: 7,
  REGISTER_SHIPPING: 8,
  SHIPPED: 9
}

const INCOMPLETE_ORDER_STATUS = {
  ON_GOING: 1,
  RESOLVE: 2
}

export default {
  STATUS_HISTORY_LABEL,
  CONFIRM_STATUS,
  PAYMENT_STATUS,
  SHIP_STATUS,
  COMPLETE_STATUS,
  STATUS_HISTORY_TYPE_ID,
  STATUS_HISTORY_TYPE_LABEL,
  CUSTOMER_ORDER_STATUS_HISTORY,
  INCOMPLETE_ORDER_STATUS
}
